/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { Form, Button, Col, Row, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import Datatable from 'shared/datatable';
import { ArrayValueReorder } from 'shared/modifiers';
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { getBuyerUrl, getBuyerHeaders } from 'shared/http';
import { buyerdetail, buyerdetailview, locationlist, invoiceList, buyersuspend, buyersuspendlist, buyerunsuspend, deleteuser, taxexemptstatus, secret_key,additionalAddressList,buyerShippingAddress, buyersuspendalllist, paymentMethodCount, buyerunsuspendalllist,buyersuspendcount } from 'shared/settings/apiconfig';
import Validators from 'shared/validators';
import { ToasterMessage } from 'shared/toast/toast';
import InvoiceView from './InvoiceView';
import { Link } from 'react-router-dom';

// style imports
import './BuyerEdit.scss';
import { error } from 'highcharts';
import { SUSPENSION_REASON, UNSUSPENSION_REASON } from 'shared/settings/config';
import { NoData } from 'features/components/redirect/NoData';
import { navigateToHelpCenter } from 'shared/utils/utils';

/**
 * this page is used to list buyers
 * 
 * @param props
 * 
 * @returns html code to render the buyers list
 * 
**/

export class BuyerEdit extends Component {

    buyerId;
    tooltipRef;
    locationOptions;
    config;
    dataTable;
    search;

    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.prevPath = this.props.location.state?.prevPath ? { pathname: this.props.location.state.prevPath, state: { saletitle: this.props.location.state.saletitle } } : '/buyer';
        this.buyerId = this.props.location.pathname.slice(this.props.location.pathname.lastIndexOf('/') + 1);
        this.state = {
            form: {
                id: '',
                active: '',
                firstname: '',
                lastname: '',
                email: '',
                isEmailVerfied: false,
                mobile: '',
                isMobileVerfied: false,
                address1: '',
                address2: '',
                zipcode: '',
                state: '',
                city: '',
                country: '',
                total: '',
                pending: '',
                suspendedLocations: [],
                filteredsuspendedLocations: [],
                membershipCompleted: '',
                suspend: {
                    locationid: { value: [], error: '', valid: false },
                    reason: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(400)] },
                    selectedAll: false,
                    selectedLocation: '',
                    // description: { value: '', error: '', valid: false, validators: [Validators.required] },
                    valid: false,
                    reasonModal: false,
                    // ispublic: { value: false },
                    suspensiontype: { value: '', error: '', valid: false, validators: [Validators.required()] },
                    alllocation: false
                },
                unsuspend: {
                    locationid: { value: [], error: '', valid: false },
                    selectedAll: false,
                    selectedLocation: '',
                    valid: false
                },
                modifieddate: '',
                activeCount: '',
                inActiveCount: '',
                modifieddatename: '',
                modifieddatenickname: '',
                unsuspendReason: {
                    locationid: { value: [], error: '', valid: false },
                    revokereason: { value: '', error: '', valid: false, validators: [Validators.required(), Validators.maxLength(400)] },
                    selectedAll: false,
                    selectedLocation: '',
                    valid: false,
                    unsuspendReasonModal: false,
                    revoketype: { value: '', error: '', valid: false, validators: [Validators.required()] },
                    alllocation: false,
                },
            },
            buyeradditionalAddressList: [],
            shippingAddr: {
                address1: '',
                address2: '',
                zipcode: '',
                state: '',
                city: '',
                country: '',
                modifieddate:''
            },
            primaryAddr: {
                address1: '',
                address2: '',
                zipcode: '',
                state: '',
                city: '',
                country: '',
                modifieddate:''
            },
              paymentAddr: {
                address1: '',
                address2: '',
                zipcode: '',
                state: '',
                city: '',
                country: '',
                modifieddate:''
            },
            taxexemptColor: '',
            buttonText:'',
            errorpageredirect: false,
            locations: [],
            unsuspendedLocationList: [],
            loading: true,
            suspendLoading: false,
            deleteLoading: false,
            suspendModal: false,
            unsuspendModal: false,
            invoiceModal: false,
            invoiceId: '',
            searchLocationId: '',
            searchData: true,
            disableSuspend: false,
            isSuspended: false,
            suspendStatus: { show: false, type: '', message: '' },
            resetStatus: { show: false, type: '', message: '' },
            deleteStatus: { show: false, type: '', message: '' },
            filterSearch: {
                buyerid: { value: Number(this.buyerId), field: 'buyerid', op: '=', join: 'AND' },
            },
            resetModal: false,
            deleteModal: false,
            maintain: props.location.state,
            conformButton: false,
            UnsuspendDisable: false,
            buyerToken: '',
            showSuspendedModal: false,
            suspendList: [],
            unsuspendList: [],
            unsuspensionModal: false,
            suspendDisable: false,
            suspendDataLoading: false,
            suspensionlocationlist: [],
            unsuspensionlocationlist: [],
            invoiceType: '',
            errorType: ''
        }
        this.config = {
            url: invoiceList,
            params: {},
            columns: [
                { name: 'Location', property: 'locationtitle', sort: true, width: '130px' },
                { name: 'Sale', property: 'saletitle', sort: true, width: '250px' },
                { name: 'Invoice Generated Date', property: 'createddate', sort: true, width: '200px', columnType: 'custom', customColumn: this.customDate },
                { name: 'Invoice Amount', property: 'invoiceamount', sort: true, width: '150px', columnType: 'custom', customColumn: this.customAmount },
                { name: 'Sale Type', property: 'type', sort: true, width: '120px' },
                { name: 'Status', property: 'invoicestatus', sort: true, width: '120px' },
                { name: 'Invoice ID', property: 'invoicenumber', sort: true, width: '150px', columnType: 'custom', customColumn: this.customInvoice },
            ],
            sort: [{ field: 'id', direction: 'desc' }],
            pagination: true,
            field: ["locationtitle", "saletitle","createddate", "saleid", "invoiceamount", "type", "invoicestatus", "id", "buyerid", "invoicenumber",'view'],
            ignoreRowBackground: true
        };

        this.tooltipRef = createRef();
        this.locationOptions = [];
        this.approveBack = false;
    }

    componentDidMount() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
        this.getBuyerToken();
        localStorage.setItem('prevbuyerId', this.buyerId)
        this.getAddressDetail();
        this.getAdditonalAddressDetail();
    }
    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToList();
        }
    }

    customInvoice = (values) => {
        return (
            <div className="d-flex">
                <div className="" style={{ paddingTop: "3%" }}>{values['invoicenumber']}</div>
                <div className="">
                    <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Seller_invoice.svg`} className="text-dark" style={{
                        cursor: values.view ? "pointer" : "not-allowed",
                        opacity: values.view ? 1 : 0.5
                    }}
                        onClick={() => { values.view && this.setState({ invoiceModal: true, invoiceId: values['id'], invoiceType: values['type'] }) }}
                        alt="invoice" height="30px" width="30px" />
                </div>
            </div>
        );
    }

    customAmount = (values) => {
        return (
            <span>${values['invoiceamount'].toFixed(2)}</span>
        );
    }
    customDate = (value) => {
        if (value['createddate']) {
            return `${ moment.utc(value['createddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    getBuyerToken() {
        axios.get(getSellerUrl(`${secret_key}`), getSellerHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                this.setState({
                    buyerToken: response.data.accessToken,
                }, () => { 
                    this.getBuyerDetail();
                });
            }
        }).catch(error => {
            if(error.response.status == 401 || error.response.status == 404) {
                this.setState({
                    errorpageredirect: true,
                    errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                })
            }
        });
    }

    /* get buyer detail */
    getBuyerDetail = async () => {
        try {
            // Set loading true initially
            this.setState({ loading: true });

            //Get Buyer Details
            const buyerPostData = {
                field: [
                    'id', 'firstname', 'lastname', 'email', 'mobile', 'emailverified', 'mobileverified',
                    'total', 'active', 'address1', 'address2', 'zipcode', 'state', 'city', 'country',
                    'modifieddate', 'modifieddatename', 'modifieddatenickname', 'membershipCompleted', 'taxexemptdate'
                ]
            };

            const buyerResponse = await axios.post(getSellerUrl(`${buyerdetail}/${this.buyerId}`),JSON.stringify(buyerPostData),getSellerHeaders());

            const buyerData = buyerResponse.data.data[0];

                localStorage.setItem('prevfirstname', buyerData.firstname)
                localStorage.setItem('prevlastname', buyerData.lastname)
                localStorage.setItem('prevbuyerId', this.buyerId)

                this.setState({
                    form: {
                        ...this.state.form,
                        firstname: buyerData.firstname,
                        lastname: buyerData.lastname,
                        email: buyerData.email,
                        isEmailVerfied: buyerData.emailverified,
                        mobile: buyerData.mobile,
                        isMobileVerfied: buyerData.mobileverified,
                        total: buyerData.total,
                        id: buyerData.id,
                        active: buyerData.active,
                        address1: buyerData.address1,
                        address2: buyerData.address2,
                        zipcode: buyerData.zipcode,
                        state: buyerData.state,
                        city: buyerData.city,
                        country: buyerData.country,
                        modifieddate: buyerData.modifieddate,
                        modifieddatename: buyerData.modifieddatename,
                        modifieddatenickname: buyerData.modifieddatenickname,
                        taxexemptdate: buyerData.taxexemptdate,
                        membershipCompleted : buyerData.membershipCompleted
                    }
                },()=>{
                    this.suspentioncount();
                });

            //Get Location List
            const locationResponse = await axios.post(
                getSellerUrl(locationlist),
                JSON.stringify({ field: ['id', 'title'] }),
                getSellerHeaders()
            );

            let defaultLocationId = null;
            if (locationResponse.data.data.length > 0) {
                const locations = ArrayValueReorder(locationResponse.data.data, 'title');
                this.locationOptions = locations.map(location => ({ title: location['title'], id: location['id'] }));
                defaultLocationId = '';

                this.setState({
                    locations,
                    searchLocationId: defaultLocationId
                }, () => {
                    if (this.state.searchLocationId) this.exemptStatus(this.state.searchLocationId);
                    this.buyerDetailView(this.state.searchLocationId);
                });
            }

            //Get Suspended Locations
            const suspendPostData = {
                filter: [{ field: 'buyerid', value: Number(this.buyerId), op: '=', join: 'AND' }]
            };

            const suspendResponse = await axios.post(getSellerUrl(buyersuspendlist), JSON.stringify(suspendPostData), getSellerHeaders());
                if (suspendResponse.data.data.length > 0) {
                    this.setState({
                        suspendedLocationList : suspendResponse.data.data,
                        form: {
                            ...this.state.form,
                            suspendedLocations: suspendResponse.data.data,
                            filteredsuspendedLocations: suspendResponse.data.data
                        }
                    });

                // Remove suspended locations from locationOptions
                suspendResponse.data.data.forEach(element => {
                    const index = this.locationOptions.findIndex(el => el.id === element.locationid);
                    if (index > -1) this.locationOptions.splice(index, 1);
                });
            }

            //Get Payment Method Count
            const paymentResponse = await axios.get(getSellerUrl(`${paymentMethodCount}${this.buyerId}`), getSellerHeaders());

                const paymentMethodData = paymentResponse.data.data;
                this.setState({
                    form: {
                        ...this.state.form,
                        activeCount: paymentMethodData.activeCount,
                        inActiveCount: paymentMethodData.inActiveCount
                    }
                })

            //Final state updates
            this.setState({
                loading: false,
                unsuspendedLocationList: this.locationOptions,
                isSuspended:
                    (defaultLocationId === '' && suspendResponse.data.data.length > 0) ||
                        suspendResponse.data.data.findIndex(el => el.locationid === defaultLocationId) > -1 ? true
                        : false
            });

        } catch (error) {
                this.setState({
                    loading: false,
                });
                if(error.response?.status == 401 || error.response?.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                });
            }
        }
    };

    buyerDetailView = (locationid) => {
        let filterArray = [];
        if(locationid) {
            filterArray.push({ field: 'locationid', value: locationid, op: '=', join: 'AND' })
        }
        const buyerViewPostData = {
            field: [
                "invoicepaidcount",
                "invoiceunpaidcount",
                "itemswoncount",
                "suspendedcount",
                "unsuspendedcount",
                "itemsbidcount"
            ],
            filter: filterArray
        }
        axios.post(getSellerUrl(`${buyerdetailview}/${this.buyerId}`), JSON.stringify(buyerViewPostData), getSellerHeaders()).then(response => {
            this.setState({
                form: {
                    ...this.state.form,
                    bidWonCount: response.data.data[0].bidWonCount,
                    // buyerSuspendCount: response.data.data[0].buyerSuspendCount,
                    invoicepaidcount: response.data.data[0].invoicepaidcount,
                    invoiceunpaidcount: response.data.data[0].invoiceunpaidcount,
                    itemBidCount: response.data.data[0].itemBidCount,
                    nickname: response.data.data[0].nickname,
                    signupdate: response.data.data[0].signupdate,
                    // unsuspendedcount: response.data.data[0].unsuspendedcount
                }
            })
        }).catch(error => {
            if(error.response.status == 401 || error.response.status == 404) {
                this.setState({
                    loading: false,
                    errorpageredirect: true,
                    errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                })
            }
        })

    }
    suspentioncount = () => {
        axios.get(getBuyerUrl(`${buyersuspendcount}${this.buyerId}`), getBuyerHeaders(this.state.buyerToken)).then(
            response => {
                if (response.data.status === 'success') {
                    this.setState({
                        suspensionlocationlist: response.data.data.suspended_data,
                        unsuspensionlocationlist: response.data.data.unsuspended_data,
                        form: {
                            ...this.state.form,
                            buyerSuspendCount: response.data.data.suspended_count,
                            unsuspendedcount: response.data.data.unsuspended_count
                        }
                    })
                 
                }
            }).catch(
                error => {
                   
                }
            );
      

    }

    exemptStatus = (locId) => {
        let filterArray = [
            { field: 'buyerid', value: Number(this.buyerId), op: '=', join: 'AND' }
        ]
        if(locId) {
            filterArray.push({ "field": "locationid", "value": [[locId]], op: 'IN', join: 'AND' })
        }
        const taxExemptStatusData = { 
            filter: filterArray
        };
        axios.post(getBuyerUrl(taxexemptstatus), JSON.stringify(taxExemptStatusData), getBuyerHeaders(this.state.buyerToken)).then((result) => {
            
            let txt = null;
            let color = null;
            if (result?.data?.data?.exemptedstatus === 'NOTAXEXEMPTION') {
                txt = 'No Tax Exemption';
                color = 'white';
            }
            if (result?.data?.data?.exemptedstatus === 'PENDING') {
                color = 'red';
                txt = 'Tax Exemption Not Added';

            }
            if (result?.data?.data?.exemptedstatus === 'EXEMPTED') {
                color = 'green';
                txt = 'Tax Exemption Added';
            }
            if (result?.data?.data?.exemptedstatus === 'EXPIRED') {
                color = 'orange';
                txt = 'Tax Exemption Expired';
            }
            this.setState({
                taxexemptColor: color,
                buttonText: txt,
            })
        }).catch(error=>{

        })
    }

    /* Tooltip for suspended locations */
    suspendedToolTip = () => {
        return (
            <div>
                <div className="text-secondary"> Suspended Locations</div>
                {
                    this.state.form.suspendedLocations.length > 0 ?
                        this.state.form.suspendedLocations.map(
                            (suspendLocation, index) => (
                                <div className={index !== this.state.form.suspendedLocations.length - 1 ? 'border-bottom' : ''}>
                                    {index + 1}. {this.state.locations.find(el => el['id'] === suspendLocation['locationid'])['title']}
                                </div>
                            )
                        ) :
                        <span>- - - - -</span>
                }
            </div>
        );
    }

    /* Enable suspend modal */
    setSuspendModal = (value) => {
        this.setState({ 
            form: {
                ...this.state.form,
                suspend: {
                    ...this.state.form.suspend,
                    reasonModal: value,
                }
            }
        });
    }

    /* Called when input changes */
    suspendInputChange = (event, control, name, id = null) => {
        let eventValue = '';
        let inputError = '';

        if (name === 'locationid') {
            eventValue = this.state.form[control].locationid.value;
            if (id === 'all') {
                let ids = [];
                if (!this.state.form[control].selectedAll) {
                    if (control === 'suspend') {
                        this.state.unsuspendedLocationList.forEach(location => {
                            ids.push(location['id']);
                        });
                    }
                    else {
                        this.state.form.filteredsuspendedLocations.forEach(location => {
                            ids.push(location['locationid']);
                        });
                    }
                    eventValue = ids;
                }
                else
                    eventValue = []
            }
            else {
                if (this.state.form[control].locationid.value.includes(id)) {
                    eventValue.splice(eventValue.indexOf(id), 1);
                }
                else
                    eventValue.push(id);
            }
            if (!eventValue.length)
                inputError = 'Please enter value';
        }
        else {
            if(name === 'ispublic') {
                eventValue = event.target.checked ? true : false
            } else {
                eventValue = event.target.value;
            }
        }
        /*validation */
        if (Object.keys(this.state.form[control][name]).includes('validators')) {
            for (let validator of this.state.form[control][name].validators) {
                inputError = validator(eventValue);
                if (inputError) break;
            }
        }
        this.setState({
            form: {
                ...this.state.form,
                [control]: {
                    ...this.state.form[control],
                    [name]: {
                        ...this.state.form[control][name],
                        value: eventValue,
                        error: inputError,
                        valid: !Boolean(inputError)
                    }
                }
            }
        }, () => {
            let valid = false;
            let selectedAllLocation = this.state.form[control].selectedAll;
            if (this.state.form[control].locationid.value.length)
                valid = true;
            if (name === 'locationid' && id === 'all')
                selectedAllLocation = !this.state.form[control].selectedAll;
            if (name === 'locationid' && id !== 'all') {
                selectedAllLocation = this.state.form[control].locationid.value.length ? selectedAllLocation : false;
                this.checkBoxChecked(eventValue, control);
            }
            this.setState({
                form: {
                    ...this.state.form,
                    [control]: {
                        ...this.state.form[control],
                        valid: valid,
                        selectedAll: selectedAllLocation,
                        alllocation: selectedAllLocation
                    }
                }
            });
        });
    }

    updateSuspend = async () => {
        const suspendPostData = {
            filter: [
                { field: 'buyerid', value: Number(this.buyerId), op: '=', join: 'AND' }
            ]
        };
        await axios.post(getSellerUrl(buyersuspendlist), JSON.stringify(suspendPostData), getSellerHeaders())
            .then(response => {
                this.setState({
                    form: {
                        ...this.state.form,
                        suspendedLocations: response.data.data,
                        filteredsuspendedLocations: response.data.data
                    }
                });

                response.data.data.forEach(element => {
                    let index = this.locationOptions.findIndex(el => el['id'] === element['locationid']);
                    if (index > -1) {
                        this.locationOptions.splice(index, 1);
                    }
                });
                this.setState({ 
                    unsuspendedLocationList: this.locationOptions,
                    isSuspended: (this.state.searchLocationId == '' && response.data.data.length > 0) || response.data.data.findIndex(el => el['locationid'] === this.state.searchLocationId) > -1 ? true : false,
                    
                    // form: {
                    //     ...this.state.form,
                    //     buyerSuspendCount: response.data.data.length,
                    // }
                });
                this.buyerDetailView(this.state.searchLocationId);
            })
            .catch(error => {
                // toast.error(error.response.data.message);
            });
    };

    /* Submit suspend data */
    submitSuspend = async () => {
        this.setState({ suspendLoading: true, suspendDataLoading: true });
        let data = [];

        this.state.form.suspend.locationid.value.forEach(value => {
            if (value['suspendid'] === undefined) {
                data.push({
                    buyerid: Number(this.buyerId),
                    locationid: value,
                    reason: this.state.form.suspend.reason.value,
                    suspensiontype: this.state.form.suspend.suspensiontype.value,
                });
            }
        });
        await axios.post(getSellerUrl(buyersuspend), JSON.stringify({ data: {locations: data, alllocations: this.state.form.suspend.alllocation}}), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({
                        suspendDataLoading: false,
                        suspendStatus: { show: true, type: 'success', message: 'Saved' },
                        conformButton: true
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                form: {
                                    ...this.state.form,
                                    suspend: {
                                        ...this.state.form.suspend,
                                        valid: false,
                                        selectedLocation: '',
                                        reasonModal: false,
                                        selectedAll: false,

                                        locationid: {
                                            ...this.state.form.suspend.locationid,
                                            value: []
                                        },
                                        reason: {
                                            ...this.state.form.suspend.reason,
                                            value: '',
                                            error: '',
                                            valid: false
                                        },
                                        suspensiontype: { value: '' },
                                    }
                                },
                                suspendLoading: false,
                                suspendStatus: { show: false, type: '', message: '' },
                                suspendModal: false,
                                conformButton: false
                            });
                            this.updateSuspend();
                            this.suspentioncount()
                        }, 3000);
                    });
                }
            })
            .catch(error => {
                this.setState({
                    suspendLoading: false,
                    suspendStatus: { show: true, type: 'danger', message: error.response.data.message }
                });

            });
    }

    /* set search to filter table data */
    enableSearch = (event) => {
        let isLocationSuspended = false;
        this.state.form.suspendedLocations.forEach(element => {
            if (Number(element['locationid']) === Number(event.target.value))
                isLocationSuspended = true;
        })
        this.setState({
            searchLocationId: event.target.value,
            isSuspended: isLocationSuspended
        }, () => {
            let search = {};
            search = {
                locationid: { value: this.state.searchLocationId ? Number(this.state.searchLocationId) : '', field: 'locationid', op: '=', join: 'AND' },
                buyerid: { ...this.state.filterSearch.buyerid, join: 'AND' }
            }
            this.setState({
                filterSearch: search,
                searchData: true
            }, () => {
                if(this.state.searchLocationId) {
                    this.exemptStatus(Number(this.state.searchLocationId));
                }
                this.dataTable.current.searchData();
            });
            this.buyerDetailView(this.state.searchLocationId)
        });
    }

    /* update the data when changed */
    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    /* Navigate to tax exemption page */
    navigateTaxExemption = () => {
        let state = { firstname: this.state.form.firstname, lastname: this.state.form.lastname, id: this.buyerId, state: this.state.maintain,locationId : parseInt(this.state.searchLocationId) };
        this.props.history.push({ pathname: `/buyer/edit/${this.buyerId}/taxexemption`, state });
    }

    /* resend suspend data when cancel */
    resetSuspend = () => {
        this.setState({
            suspendModal: false,
            unsuspendedLocationList: this.locationOptions,
            form: {
                ...this.state.form,
                suspend: {
                    locationid: { value: [], error: '', valid: false },
                    reason: { value: [], error: '', valid: false, validators: [Validators.required] },
                    selectedAll: false,
                    selectedLocation: '',
                    valid: false,
                    reasonModal: false,
                    suspensiontype: { value: '' },
                    alllocation: false
                }
            }
        })
    }

    navigateToList = () => {
        this.props.history.push({ pathname: this.props.location.state?.prevPath ? this.prevPath.pathname : '/buyer', state: this.state?.maintain });
    };

    /* check selected location id*/
    checkBoxChecked = (id, control) => {
        if (this.state.form[control].locationid.value.includes(id))
            return true;
        else
            return false;
    }

    /* filter unsuspeded location to suspend */
    filterUnSuspendLocation = (value) => {
        let locationList = [];
        if (value) {
            locationList = this.locationOptions.filter(x => x.title.toLowerCase().includes(value.toLowerCase()));
        }
        else {
            locationList = this.locationOptions;
        }
        this.setState({
            unsuspendedLocationList: locationList,
            form: {
                ...this.state.form,
                suspend: {
                    ...this.state.form.suspend,
                    selectedLocation: value,
                    // locationid: { value: [], error: '', valid: false },
                    // reason: { value: '', error: '', valid: false },
                    // selectedAll: false,
                    // valid: false
                }
            }
        });
    }

    /* Enable reason modal */
    setReasonModal = () => {
        this.setState({
            form: {
                ...this.state.form,
                suspend: {
                    ...this.state.form.suspend,
                    reasonModal: false,

                },
            },
            suspendModal: true
        });
    }

    /* Enable unsuspend modal */
    setUnSuspendModal = () => {
        this.setState({ unsuspendModal: true });
    }

    /* filter suspend location to unsuspend */
    filterSuspendLocation = (value) => {
        let locationList = [];
        if (value) {
            locationList = this.state.form.suspendedLocations.filter(x => x.locationtitle.toLowerCase().includes(value.toLowerCase()));
        }
        else {
            locationList = this.state.form.suspendedLocations
        }
        this.setState({
            form: {
                ...this.state.form,
                filteredsuspendedLocations: locationList,
                unsuspend: {
                    ...this.state.form.unsuspend,
                    selectedLocation: value,
                    // locationid: { value: [], error: '', valid: false },
                    // selectedAll: false,
                    // valid: false
                }
            }
        });
    }
    getAddressDetail = () => {
        let addressData = {
            filter: [
            {
                "field": "buyerid",
                "value": this.buyerId,
                "op": "=",
                "join": "AND"
            },
            {
                "field": "shipping",
                "value": 1,
                "op": "=",
                "join": "OR"
            },
            {
                "field": "addresstype",
                "value": "Primary",
                "op": "=",
                "join": "AND"
            }
        ]
        }
        axios.post(getSellerUrl(`${buyerShippingAddress}`), JSON.stringify(addressData), getSellerHeaders())
            .then(({ data, status }) => {
                if (status === 200) {
                    const addressTypes = {};

                    data?.data?.forEach(address => {
                        addressTypes[address.addresstype] = address;
                    });
                    let value = data.data

                    this.setState({
                        primaryAddr: addressTypes.Primary || {},
                        shippingAddr: addressTypes.Shipping ?  addressTypes.Shipping : addressTypes.Primary.shipping ? addressTypes.Primary : {},
                        paymentAddr: addressTypes.Payment || {}
                    });
                }
        }).catch(error => {
            this.setState({
                loading: false,
            });
            if(error.response?.status == 401 || error.response?.status == 404) {
                this.setState({
                    errorpageredirect: true,
                    errorType: error.response?.status == 401 ? 'expiryError' : error.response?.status == 404 ? 'noData' : ''
                })
            }
        })
    }

    getAdditonalAddressDetail = () => {
        let addressData = {
            filter: [
            {
                "field": "buyerid",
                "value": this.buyerId,
                "op": "=",
                "join": "AND"
            }
        ]
        }
        axios.post(getSellerUrl(`${additionalAddressList}`), JSON.stringify(addressData), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                       buyeradditionalAddressList:  response.data?.data,
                    });
                }
        }).catch(error => {
          
        })
    }
   

    /* Submit unsuspend data */
    submitUnSuspend = async () => {
        this.setState({ suspendLoading: true });
        const data = {
            data: {
                buyerid: Number(this.buyerId),
                locationid: this.state.form.unsuspend.locationid.value,
                revokereason: this.state.form.unsuspendReason.revokereason.value,
                revoketype: this.state.form.unsuspendReason.revoketype.value
            }
        }

        await axios.put(getSellerUrl(buyerunsuspend), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.state.locations.forEach(location => {
                        this.state.form.unsuspend.locationid.value.forEach(id => {
                            if (id === location['id'])
                                this.locationOptions.push({ title: location['title'], id: location['id'] });
                        })
                    })
                    this.setState({
                        suspendLoading: false,
                        suspendStatus: { show: true, type: 'success', message: 'Saved' },
                        UnsuspendDisable: true
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                form: {
                                    ...this.state.form,
                                    unsuspend: {
                                        ...this.state.form.unsuspend,
                                        valid: false,
                                        selectedLocation: '',
                                        reasonModal: false,
                                        selectedAll: false,

                                        locationid: {
                                            ...this.state.form.unsuspend.locationid,
                                            value: []
                                        },
                                        suspend: {
                                            ...this.state.form.suspend,
                                            selectedAll: false
                                        }
                                    },
                                    suspend: {
                                        ...this.state.form.suspend,
                                        selectedAll: false
                                    },
                                    unsuspendReason: {
                                        locationid: { value: [], error: '', valid: false },
                                        revokereason: { value: '', error: '', valid: false, validators: [Validators.required()] },
                                        selectedAll: false,
                                        selectedLocation: '',
                                        valid: false,
                                        unsuspendReasonModal: false,
                                        revoketype: { value: '', error: '', valid: false, validators: [Validators.required()] },
                                        alllocation: false,
                                    },
                                },
                                suspendStatus: { show: false, type: '', message: '' },
                                suspendLoading: false,
                                unsuspendModal: false,
                                UnsuspendDisable: false,
                                unsuspendedLocationList: this.locationOptions,
                                unsuspendList: []
                            });
                            this.updateSuspend();
                            this.suspentioncount();
                        }, 3000);
                    });
                }
            })
            .catch(error => {
                this.setState({
                    suspendLoading: false,
                    suspendStatus: { show: true, type: 'danger', message: error.response.data.message }
                });

            });
    }

    /* reset unsuspend */
    // resetUnSuspend = () => {
    //     this.setState({
    //         unsuspendModal: false,
    //         form: {
    //             ...this.state.form,
    //             filteredsuspendedLocations: this.state.form.suspendedLocations,
    //             unsuspend: {
    //                 locationid: { value: [], error: '', valid: false },
    //                 selectedAll: false,
    //                 selectedLocation: '',
    //                 valid: false
    //             }
    //         }
    //     })
    // }
    // resetPassword = async () => {
    //     const data = {
    //         data: {
    //             email: this.state.form.email
    //         }
    //     };
    //     await axios.post(getBuyerUrl(defaultPassword), JSON.stringify(data),getBuyerHeaders())
    //     .then(response => {
    //         if (response.status === 200) {
    //             this.setState({
    //                 ...this.state,
    //                 resetModal:false,
    //                 resetStatus: { show: true, type: 'success', message:"Password reset mail has sent" }
    //             },()=>{
    //                 setTimeout(() => {
    //                     this.setState({
    //                         resetStatus: { show: false, type: '', message: '' },
    //                     });
    //                 }, 3000);
    //             });
    //         }
    //     })
    //     .catch(error => {
    //         this.setState({
    //             ...this.state,
    //             resetModal:false,
    //             resetStatus: { show: true, type: 'danger', message: error.response.data.message }
    //         },()=>{
    //             setTimeout(() => {
    //                 this.setState({
    //                     resetStatus: { show: false, type: '', message: '' },
    //                 });
    //             }, 3000);
    //         }
    //         );
    //     });
    // }

    deleteUser = async () => {
        this.setState({ deleteLoading: true });
        const data = {
            data: {
                id: this.state.form.id
            }
        };
        await axios.delete(getBuyerUrl(deleteuser + this.state.form.id), { ...getBuyerHeaders(), data: { 'data': data } })
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        ...this.state,
                        deleteLoading: false,
                        deleteStatus: { show: true, type: 'success', message: "User has been successfully deleted" }
                    }
                    );
                }
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    deleteLoading: false,
                    deleteStatus: { show: true, type: 'danger', message: error.response.data.message }
                }
                );
            });
    }

    redirectDeleteModal = () => {
        this.setState({ deleteModal: false })
        if (this.state.deleteStatus.type === 'success') {
            this.setState({
                form: {
                    ...this.state.form,
                    active: 0
                }
            });
            // this.props.history.push({ pathname: this.props.location.state?.prevPath ? this.prevPath.pathname : '/buyer', state: this.props.location.state?.prevPath ? this.prevPath.state : this.props.location.state });
        }
    }
    unsuspendedlocationfunction = () => {
        let sortingFunction = this.state.unsuspendedLocationList 

        sortingFunction.forEach(item => {
            item.title = item.title.trim();
        });

        sortingFunction.sort((a, b) => {
            return a.title.localeCompare(b.title);
        });
        return sortingFunction
    }

    getAddressTypeWithCount = (address, index, sortedAddresses) => {
        const count = sortedAddresses.slice(0, index + 1).filter( item => item?.addresstype?.toLowerCase() === address?.addresstype?.toLowerCase()).length;

        return `${address?.addresstype} ${count}`;
    };

    getSignupDatetime = (dateTime) => {
        const formatedDate = moment.utc(dateTime).local();
        let returnValue = formatedDate.format('MM/DD/YYYY hh:mm:ss A');
        let timeZone = moment.tz(moment.tz.guess()).zoneAbbr();

        return `${returnValue} ${timeZone}`;
    }

    openSuspendedModal = () => {
        if( this.state.form.buyerSuspendCount > 0 ){
        const suspendPostData = {
            'buyerid': this.buyerId,"locationid":this.state.suspensionlocationlist
        };
        axios.post(getSellerUrl(buyersuspendalllist), {"data" :suspendPostData}, getSellerHeaders())
            .then(response => {
                this.setState({
                    suspendList: response?.data?.data,
                    showSuspendedModal: true
                })
            })
            .catch(error => { });
        }
    }

    openUnSuspendedModal = () => {
        if(this.state.form.unsuspendedcount  > 0){
        const unsuspendPostData = {
            'buyerid': this.buyerId,"locationid":this.state.unsuspensionlocationlist
        };
        axios.post(getSellerUrl(buyerunsuspendalllist), {"data" :unsuspendPostData}, getSellerHeaders())
            .then(response => {
                this.setState({
                    unsuspendList: response?.data?.data,
                    unsuspensionModal: true
                })
            })
            .catch(error => { });
        }
    }

    /* Enable unsuspend reason modal */
    setUnSuspendReasonModal = () => {
        this.setState({
            form: {
                ...this.state.form,
                unsuspendReason: {
                    ...this.state.form.unsuspendReason,
                    unsuspendReasonModal: false,
                },
            },
            unsuspendModal: true
        });
    }

    openUnSuspendedReasonModal = (value) => {
        this.setState({
            form: {
                ...this.state.form,
                unsuspendReason: {
                    ...this.state.form.unsuspendReason,
                    unsuspendReasonModal: value
                }
            }   
        })
    }

    /* resend suspend data when cancel */
    resetUnSuspend = () => {
        this.setState({
            ...this.state,
            unsuspendModal: false,
            unsuspendedLocationList: this.locationOptions,
            form: {
                ...this.state.form,
                filteredsuspendedLocations: this.state.suspendedLocationList,
                unsuspend: { 
                ...this.state.form.unsuspend,
                locationid: { value: [], error: '', valid: false },
                selectedAll: false,
                selectedLocation: '', 
                valid: false
                },
                unsuspendReason: {
                    locationid: { value: [], error: '', valid: false },
                    revokereason: { value: '', error: '', valid: false, validators: [Validators.required()] },
                    selectedAll: false,
                    selectedLocation: '',
                    valid: false,
                    unsuspendReasonModal: false,
                    revoketype: { value: '', error: '', valid: false, validators: [Validators.required()] },
                    alllocation: false,
                }
            },
            unsuspendList: []
        })
    }

    render() {
        if (this.state.errorpageredirect) {
            // redirect to Not-Found if wrong Buyerid
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                {this.state.loading ?
                    <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div> :
                    <div>
                        <div id="backbutton" style={{ borderBottom: "1px solid #b6b6b6", padding: "1%" }}>
                            <span onClick={this.navigateToList} className="clickable">
                                <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                                <span style={{ paddingLeft: "1em" }}>Back</span>
                            </span>
                            <span className="text-secondary ml-2 pl-3" style={{ borderLeft: "1px solid" }}>{this.state.form.lastname},{this.state.form.firstname}</span>
                        </div>

                        <div className="buyerClass">
                            <div id="toaster" className={this.state.resetStatus.show ? " d-flex flex-row align-items-center justify-content-center toaster" : ''} >
                                {
                                    this.state.resetStatus.show ?
                                        <ToasterMessage type={this.state.resetStatus.type} message={this.state.resetStatus.message} className="alert-handle"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="px-3 buyerDetail mt-3">
                            <div className="mt-3" style={{fontWeight:'bold', fontSize:'15px', textAlign:'left'}}>
                                Profile :
                                <span className='border-set' style={{ width:'50px' }}></span>
                            </div>
                                <Row >
                                    <Col className="py-3">
                                        <label>Name</label>
                                        <p>{this.state.form.lastname}, {this.state.form.firstname}</p>
                                    </Col>
                                    <Col className="py-3">
                                        <label>Sign Up Date</label>
                                        <p style={{ wordBreak: "break-word" }}>{this.state.form.signupdate ? this.getSignupDatetime(this.state.form.signupdate) : '- - -'}</p>
                                    </Col>
                                    <Col className="py-3">
                                        <label>Name Change Last Modified Date</label>
                                        <p style={{ wordBreak: "break-word" }}>{this.state.form.modifieddatename ? this.getSignupDatetime(this.state.form.modifieddatename) : '- - -'}</p>
                                    </Col>
                                    <Col className="py-3">
                                        <label>Email</label>
                                        <p style={{ wordBreak: "break-word" }}>{this.state.form.email ? this.state.form.email : '- - -'}</p>
                                        <p>{this.state.form.email ? this.state.form.isEmailVerfied ? <span className="text-success">Verified </span> : <span className="text-warning">Not Verified</span> : ''}</p>
                                    </Col>
                                    <Col className="py-3">
                                        <label>Phone</label>
                                        <p>{this.state.form.mobile ? this.state.form.mobile : '- - -'}</p>
                                        <p>{this.state.form.mobile ? this.state.form.isMobileVerfied ? <span className="text-success">Verified </span> : <span className="text-warning">Not Verified</span> : ''}</p>

                                    </Col>
                                    <Col className="py-3">
                                        <label>User Name</label>
                                        <p style={{ wordBreak: "break-word" }}> { this.state.form.membershipCompleted && this.state.form.nickname   ?  <img src={`${process.env.PUBLIC_URL}/static/images/membership.png`} alt="" width={'20px'}  />: '' } {this.state.form.nickname ? this.state.form.nickname : '- - -'}  </p>
                                    </Col>
                            
                                  
                                    {/* <Col className="py-3"> */}
                                    {/* <label>Total purchased to Date</label>
                                    <p>{this.state.form.total ? `${this.state.form.total}` : '- - -'}{this.state.form.pending ? `. [${this.state.form.pending} Pending]` : ''}</p> */}
                                    {/* <div style={{height: "20px"}}></div>
                                    <div className="w-100 d-flex">
                                        <Button className="btn mt-4" style={{ height: "fit-content", height: "-moz-fit-content",marginTop:'15px',backgroundColor: "#129A4E",color: "#FFFFFF"}} onClick={() => this.setState({resetModal:true})}>Reset Password</Button>
                                    </div>   */}
                                    {/* </Col> */}
                                   
                                </Row>
                                <div className="mb-3 mt-3" style={{fontWeight:'bold', fontSize:'15px', textAlign:'left'}}>
                                    Payment Method Details:
                                    <span className='border-set' style={{ width:'180px' }}></span>
                                </div>
                                <Row style={{marginBottom: '10px', marginTop:'20px'}}>
                                    <Col>
                                        <label>Active</label>
                                        <p>{this.state.form.activeCount}</p>
                                    </Col>
                                    <Col>
                                        <label>In Active</label>
                                        <p>{this.state.form.inActiveCount}</p>
                                    </Col>
                                    <Col></Col>
                                    <Col></Col>
                                    <Col></Col>
                                    <Col></Col>
                                </Row>
                                <div className="mb-3 mt-3"  style={{fontWeight:'bold', fontSize:'15px', textAlign:'left'}}>
                                    Address :
                                    <span className='border-set' style={{ width:'60px' }}></span>
                              </div>
                              <div className='address-table-header'>
                                <div className='address-table' >
                                <Row className='mb-3' style={{ fontWeight:'bold'}}>
                                    <Col>
                                        Address Type
                                    </Col>
                                    <Col>
                                        Address Line 1
                                    </Col>
                                    <Col>
                                        Address Line 2
                                    </Col>
                                    <Col>
                                         City
                                    </Col>
                                    <Col>
                                        State
                                    </Col>
                                    <Col>
                                        Zip Code
                                    </Col>
                                    <Col>
                                        Last Modified Date
                                    </Col>
                                </Row>
                                <Row className='mb-2'>
                                    <Col>
                                        {"Primary"}
                                    </Col>

                                    <Col style={{wordBreak:'break-word'}}>
                                        {this.state?.primaryAddr?.address1 ? this.state?.primaryAddr?.address1 : "- - -"}</Col>

                                    <Col style={{wordBreak:'break-word'}}>
                                        {this.state?.primaryAddr?.address2 ? this.state?.primaryAddr?.address2 : "- - -"}</Col>

                                    <Col>
                                        {(this.state?.primaryAddr?.city ? this.state?.primaryAddr?.city : '- - -') }
                                    </Col>
                                    <Col>
                                        {(this.state?.primaryAddr?.state ? this.state?.primaryAddr?.state : '- - -')}
                                    </Col>
                                    <Col>

                                        {(this.state?.primaryAddr?.zipcode ? this.state?.primaryAddr?.zipcode : '- - -')}
                                    </Col>
                                    <Col>
                                        {this.state?.primaryAddr?.modifieddate ? this.getSignupDatetime(this.state?.primaryAddr?.modifieddate ) : '- - -'}
                                    </Col>
                                </Row> 
                                <Row className='mt-3'>
                                    <Col>
                                        {"Shipping"}
                                    </Col>

                                    <Col style={{wordBreak:'break-word'}}>
                                        {this.state?.shippingAddr?.address1 ? this.state.shippingAddr?.address1 : "- - -"}</Col>

                                    <Col style={{wordBreak:'break-word'}}>
                                        {this.state?.shippingAddr?.address2 ? this.state.shippingAddr?.address2 : "- - -"}</Col>

                                    <Col>
                                        {(this.state?.shippingAddr?.city ? this.state?.shippingAddr?.city :  "- - -") }
                                    </Col>
                                    <Col>
                                        {(this.state?.shippingAddr?.state ? this.state?.shippingAddr?.state :  "- - -")}
                                    </Col>
                                    <Col>

                                        {(this.state?.shippingAddr?.zipcode ? this.state?.shippingAddr?.zipcode :  "- - -")}
                                    </Col>
                                    <Col>
                                         {this.state?.shippingAddr?.modifieddate ? this.getSignupDatetime(this.state?.shippingAddr?.modifieddate ) : '- - -'}
                                    </Col>
                                </Row> 
                                        <Row className='mt-3'>
                                            <Col>
                                                {"Payment"}
                                            </Col>

                                            <Col style={{ wordBreak: 'break-word' }}>
                                                {this.state?.paymentAddr?.address1 ? this.state.paymentAddr?.address1 : "- - -"}</Col>

                                            <Col style={{ wordBreak: 'break-word' }}>
                                                {this.state?.paymentAddr?.address2 ? this.state.paymentAddr?.address2 : "- - -"}</Col>

                                            <Col>
                                                {(this.state?.paymentAddr?.city ? this.state?.paymentAddr?.city : "- - -")}
                                            </Col>
                                            <Col>
                                                {(this.state?.paymentAddr?.state ? this.state?.paymentAddr?.state : "- - -")}
                                            </Col>
                                            <Col>

                                                {(this.state?.paymentAddr?.zipcode ? this.state?.paymentAddr?.zipcode : "- - -")}
                                            </Col>
                                            <Col>
                                                {this.state?.paymentAddr?.modifieddate ? this.getSignupDatetime(this.state?.paymentAddr?.modifieddate) : '- - -'}
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className='address-table-header'>
                                      
                                            <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                                Other Address's on Profile :
                                                <span className='border-set' style={{ width: '192px' }}></span>
                                            </div>
                                            
                                        <div className='address-table'>
                                            <Row className='mb-3' style={{ fontWeight: 'bold' }}>
                                                <Col>Address Type</Col>
                                                <Col>Address Line 1</Col>
                                                <Col>Address Line 2</Col>
                                                <Col>City</Col>
                                                <Col>State</Col>
                                                <Col>Zip Code</Col>
                                                <Col>Last Modified Date</Col>
                                            </Row>
                                           {this.state?.buyeradditionalAddressList ?  <>

                                            {this.state?.buyeradditionalAddressList?.map((address, index, arr) => (
                                                <Row className="mb-3" key={index}>
                                                    <Col> {address?.addresstype ? this.getAddressTypeWithCount(address, index, arr) : "- - -"} </Col>

                                                    <Col style={{ wordBreak: "break-word" }}>
                                                        {address?.address1 || "- - -"}
                                                    </Col>

                                                    <Col style={{ wordBreak: "break-word" }}>
                                                        {address?.address2 || "- - -"}
                                                    </Col>

                                                    <Col>{address?.city || "- - -"}</Col>

                                                    <Col>{address?.state || "- - -"}</Col>

                                                    <Col>{address?.zipcode || "- - -"}</Col>

                                                    <Col>
                                                        {address?.modifieddate
                                                            ? this.getSignupDatetime(address.modifieddate)
                                                            : "- - -"}
                                                    </Col>
                                                </Row>
                                            ))}
                                            </> : 
                                            <Row className="mb-3" >
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                    <Col>{"- - -"}</Col>
                                                </Row> }
                                        </div>

                                    </div>

                                </div>
                                <div className="mb-3 mt-3"  style={{fontWeight:'bold', fontSize:'15px', textAlign:'left'}}>
                                    Suspend Details:
                                    <span className='border-set' style={{ width:'120px' }}></span>
                                </div>
                                <Row className='mb-5'>
                                    <Col></Col>
                                    <Col></Col>
                                    <Col className='d-flex align-items-end'>
                                        <div style={{ marginBottom: "5px", marginRight: "5px" }}>Suspended</div> 
                                        <div className={`d-flex flex-row justify-content-center align-items-center border bg-white ${this.state.form.buyerSuspendCount > 0 ? 'clickable' : ''}`}
                                            style={{ borderRadius: "50%", height: "30px", width: "30px" }} onClick={this.openSuspendedModal}>
                                            {
                                                this.state.form.buyerSuspendCount ?
                                                    <span style={{ marginTop: "1px" }}>{this.state.form.buyerSuspendCount}</span> :
                                                    <span style={{ marginTop: "1px" }}>0</span>
                                            }
                                        </div>
                                    </Col>
                                    <Col>
                                            {/* {this.state.isSuspended || !this.state.unsuspendedLocationList.length ? <p className="text-danger">Buyer Suspended</p> : ''} */}
                                        <Button className="btn suspendButton" style={this.state.disableSuspend ? { height: "fit-content", height: "-moz-fit-content", marginTop: '24px', backgroundColor: "#999999", borderColor: "#999999", color: "black", opacity: 0.5 } : { height: "fit-content", height: "-moz-fit-content", marginTop: '24px', backgroundColor: "white", borderColor: "#29B0FF", color: "#29B0FF", whiteSpace: 'nowrap' }} disabled={!this.state.unsuspendedLocationList.length || this.state.form.active === 0} onClick={() => this.setSuspendModal(true)}>Suspend Buyer</Button>
                                    </Col>
                                    <Col>
                                        <Button className="btn suspendButton" style={{ height: "fit-content", height: "-moz-fit-content", marginTop: '24px', backgroundColor: "white", borderColor: "#FF0000", color: "#FF0000", whiteSpace: 'nowrap' }} disabled={!this.state.form.filteredsuspendedLocations.length || this.state.form.active === 0} onClick={() => this.openUnSuspendedReasonModal(true)}>UnSuspend Buyer</Button>
                                    </Col>
                                    <Col className='d-flex align-items-end'>
                                        <div style={{ marginBottom: "5px", marginRight: "5px" }}>UnSuspension's</div> 
                                        <div className={`d-flex flex-row justify-content-center align-items-center border bg-white ${this.state.form.unsuspendedcount > 0 ? 'clickable' : ''}`}
                                            style={{ borderRadius: "50%", height: "30px", width: "30px" }} onClick={this.openUnSuspendedModal}>
                                            {
                                                this.state.form.unsuspendedcount ?
                                                    <span style={{ marginTop: "1px" }}>{this.state.form.unsuspendedcount}</span> :
                                                    <span style={{ marginTop: "1px" }}>0</span>
                                            }
                                        </div>
                                    </Col>
                                    <Col></Col>
                                </Row>
                            </div>

                            <div className="px-3 buyerDetail mt-3">
                                <div className='d-flex justify-content-between'>
                                    <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                        Bidding Details :
                                        <span className='border-set' style={{ width: '110px' }}></span>
                                    </div>

                                    <div className="d-flex flex-column p-2">
                                        <Form style={{ textAlign: "flex-end" }}>
                                            <Form.Control as="select" name="buyerLocation" id="buyerLocation" defaultValue={this.state.searchLocationId} className="float-left" style={{ width: "100%" }} onChange={(event) => this.enableSearch(event)}>
                                                <option value='' key="all">All Locations</option>
                                                {
                                                    this.state.locations.map(location =>
                                                        <option value={location.id} key={location.id}>{location.title}</option>
                                                    )
                                                }
                                            </Form.Control>
                                        </Form>
                                    </div>
                                </div>
                                           
                                <Row className='mb-2'>
                                    {/* <Col className="py-3">
                                        <p>Bidder Status</p>
                                        {this.state.isSuspended ? <p className="text-danger">Buyer Suspended</p> : '---'}
                                    </Col > */}
                                    <Col className="py-3">
                                        <p>Items Won </p>
                                        {this.state.form.bidWonCount || this.state.form.bidWonCount === 0 ? this.state.form.bidWonCount : '-'}
                                    </Col >
                                    <Col className="py-3">
                                      <p>Invoices Paid</p>
                                        {this.state.form.invoicepaidcount || this.state.form.invoicepaidcount === 0 ? this.state.form.invoicepaidcount : '-'}
                                    </Col>
                                    <Col className="py-3">
                                        <p>Invoices Unpaid</p>
                                        {(this.state.form.invoiceunpaidcount || this.state.form.invoiceunpaidcount === 0 ? this.state.form.invoiceunpaidcount : '-')}
                                    </Col>
                                    <Col className="py-3">
                                        <p>Items Currently Bidding</p>
                                        {(this.state.form.itemBidCount || this.state.form.itemBidCount === 0 ? this.state.form.itemBidCount : '')}
                                    </Col>
                                </Row>
                                {/* <Row>
                                    <Col>{this.state.form.bidWonCount || this.state.form.bidWonCount === 0 ? this.state.form.bidWonCount : '-'}</Col>
                                    <Col>{this.state.form.invoicepaidcount || this.state.form.invoicepaidcount === 0 ? this.state.form.invoicepaidcount : '-'}</Col>
                                    <Col>{(this.state.form.invoiceunpaidcount || this.state.form.invoiceunpaidcount === 0 ? this.state.form.invoiceunpaidcount : '-')}</Col>
                                    <Col>{(this.state.form.itemBidCount || this.state.form.itemBidCount === 0 ? this.state.form.itemBidCount : '')}</Col>
                                </Row> */}
                                <div className="mb-3 mt-3" style={{fontWeight:'bold', fontSize:'15px', textAlign:'left'}}>
                                    Tax :
                                    <span className='border-set' style={{ width:'30px' }}></span>

                                </div>
                                <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                    <Col>
                                        {/* <label style={{ whiteSpace: 'nowrap' }}>Tax Exemption Submission Date:</label>
                                        <p>{this.state.form.taxexemptdate ? this.getSignupDatetime(this.state.form.taxexemptdate) : '- - -'}</p> */}
                                    </Col>
                                    <Col> </Col>
                                    <Col></Col>
                                    <Col>
                                        {this.state.buttonText && this.state.searchLocationId ? <Button className="mt-2 w-100" style={{ whiteSpace: 'nowrap', height: "fit-content", height: "-moz-fit-content", borderColor: this.state.taxexemptColor === 'white' ? 'black' : this.state.taxexemptColor, backgroundColor: this.state.taxexemptColor, color: this.state.taxexemptColor === 'white' ? 'black' : 'white' }} disabled={this.state.form.active === 0} onClick={() => this.navigateTaxExemption()} >{this.state.buttonText}</Button> : ''}
                                    </Col>
                                    <Col></Col>
                                    <Col></Col>
                                    <Col> </Col>
                                </Row>
                            </div>
                            <div className="row d-flex ml-2 my-3 justify-content-between">
                                <label style={{ fontsize: "1rem" }}> Location Buying History </label>
                                
                            </div>
                            <div className="row ml-2">
                                <Datatable config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData} />
                            </div>
                        </div>
                    </div>
                }
                <Modal centered show={this.state.suspendModal} className="suspendModal" scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <div className="w-100 d-flex justify-content-between">
                            <h5>Location</h5>
                            <div className="custom-header-checkbox" style={{ paddingRight: '8px' }}>
                                <Form>
                                    <div className={`custom-checkbox-div ${this.state.form.suspend.selectedAll ? 'checked' : ''}`} onClick={(event) => this.suspendInputChange(event, 'suspend', 'locationid', 'all')} />
                                </Form>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="border-bottom">
                            <div className="inputWithButton">
                                <Form.Control type="text" name="selectedLocation" className="my-3 ml-3" placeholder="Search by location name" value={this.state.form.suspend.selectedLocation} onChange={(event) => this.filterUnSuspendLocation(event.target.value)} />
                                {this.state.form.suspend.selectedLocation &&
                                    <Button variant="danger" onClick={() => this.filterUnSuspendLocation('')}>clear</Button>
                                }
                            </div>
                        </div>
                        {
                           this.unsuspendedlocationfunction()
                            .map(location =>
                                <div className="border-bottom">
                                    <div className="d-flex justify-content-between my-1 p-3">
                                        <b>{location['title']}</b>
                                        <div className="custom-header-checkbox">
                                            <Form>
                                                <div className={`custom-checkbox-div ${this.checkBoxChecked(location.id, 'suspend') ? 'checked' : ''}`} onClick={(event) => this.suspendInputChange(event, 'suspend', 'locationid', location['id'])}></div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-end align-items-end">
                        <div id="toaster" className={this.state.suspendStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                            {
                                this.state.suspendStatus.show ?
                                    <ToasterMessage type={this.state.suspendStatus.type} message={this.state.suspendStatus.message} className="alert-handle"></ToasterMessage>
                                    : null
                            }
                        </div>
                        <div className="d-flex">
                            <Button onClick={() => this.resetSuspend()} disabled={this.state.suspendLoading} className="btn-white"> Cancel</Button>
                            <Button onClick={() => this.submitSuspend()} disabled={!this.state.form.suspend.valid || this.state.suspendLoading} className="btn-secondary ml-2">Suspend {this.state.suspendDataLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
                <Modal centered show={this.state.form.suspend.reasonModal} className="reasonModal" onHide={() => this.setState({ ...this.state })} scrollable={true}>
                    <Modal.Body>
                        <div className="form-fields" style={{ width: "95%" }}>
                            <div className="d-flex" style={{ marginBottom: "10px" }}>
                                <small className='text-danger'>If you feel this customer is a threat to the network, please contact <span style={{ color: '#A50050', cursor: 'pointer' }} onClick={() => navigateToHelpCenter(this.props.history)}>CTBids.com/help-center</span> to suspend sitewide</small>
                            </div>
                            <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Label htmlFor="reason" className="required">Suspension Reason</Form.Label>
                                <Form.Control as="select" name="suspension" value={this.state.form?.suspend?.suspensiontype?.value} onChange={(event) => this.suspendInputChange(event, 'suspend', 'suspensiontype')}>
                                    <option value="" selected>--Select--</option>
                                    {
                                        SUSPENSION_REASON.map((elem, index) => {
                                            return <option key={index} value={elem}>{elem}</option>
                                        })
                                    }
                                </Form.Control> 
                            </div>
                            {/* <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Check custom type="checkbox" id="ispublic" name="ispublic" label="Is Public" checked={this.state.form?.suspend?.ispublic?.value} onChange={(event) => this.suspendInputChange(event, 'suspend', 'ispublic')} />
                            </div> */}
                            <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Label htmlFor="reason" className="required">Add Notes</Form.Label>
                                <span className="align-self-end ml-auto mb-1">{400 - this.state.form.suspend.reason.value.length}/400</span>
                            </div>
                            <div className="float-control">

                                <Form.Control as="textarea" id="reason" name="reason" value={this.state.form.suspend.reason.value} maxLength="400" className={this.state.form.suspend.reason.value ? 'form-control-active' : ''} style={{ height: '100px' }} placeholder=" " onChange={(event) => this.suspendInputChange(event, 'suspend', 'reason')} />
                                <div className="text">
                                    {
                                        this.state.form.suspend.reason.error && this.state.form.suspend.reason.error.length ? <small className="error">{this.state.form.suspend.reason.error}</small> : null
                                    }
                                </div>

                            </div>
                        </div>
                        <div>
                            <div id="toaster" className={this.state.suspendStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                {
                                    this.state.suspendStatus.show ?
                                        <ToasterMessage type={this.state.suspendStatus.type} message={this.state.suspendStatus.message} className="alert-handle"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex justify-content-center align-item-center">
                                <Button className="btn-white mx-2" onClick={() => this.resetSuspend()}>Cancel</Button>
                                <Button variant="secondary" onClick={() => this.setReasonModal()} disabled={!this.state.form.suspend.reason.value || this.state.suspendLoading || this.state.conformButton || !this.state.form.suspend.suspensiontype.value}>Confirm {this.state.suspendLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.unsuspendModal} className="suspendModal" scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <Row xs={1} sm={1} className="w-100">
                            <Col md={2}><h5>Location</h5></Col>
                            <Col md={2}><h5>Reason</h5></Col>
                            <Col md={2}><h5>Suspension Type</h5></Col>
                            <Col md={2}><h5>Effective Date</h5></Col>
                            <Col md={2}><h5>Suspended By</h5></Col>
                            <Col md={1} className="d-flex justify-content-end">
                                <div className="custom-header-checkbox" style={{ paddingRight: '5px' }}>
                                    <Form>
                                        <div className={`custom-checkbox-div ${this.state.form.unsuspend.selectedAll ? 'checked' : ''}`} onClick={(event) => this.suspendInputChange(event, 'unsuspend', 'locationid', 'all')} />
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="border-bottom">
                            <div className="inputWithButton">
                                <Form.Control type="text" name="selectedLocation" className="my-3 ml-3" placeholder="Search by location name" value={this.state.form.unsuspend.selectedLocation} onChange={(event) => this.filterSuspendLocation(event.target.value)} />
                                {this.state.form.unsuspend.selectedLocation &&
                                    <Button variant="danger" onClick={() => this.filterSuspendLocation('')}>clear</Button>
                                }
                            </div>
                        </div>
                        {
                            this.state.form.filteredsuspendedLocations
                            .slice()
                            .sort((a, b) => a.locationtitle.localeCompare(b.locationtitle))
                            .map(location => (
                                <div className="border-bottom">
                                    <Row xs={1} sm={1} className="w-100 p-3">
                                        <Col md={2} style={{ wordBreak: "break-word" }}><b>{location['locationtitle']}</b></Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{location['reason'] ? location['reason'] : 'Added to Sitewide Suspensions'}</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{location['suspensiontype'] ? location['suspensiontype'] : 'Location Status Update'}</Col>
                                        <Col md={2}><b>{moment.utc(location['effectivedate']).local().format('MM-DD-YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</b></Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{location['suspendedby'] ? location['suspendedby'] : 'System Update'}</Col>
                                        <Col md={1} className="d-flex justify-content-end">
                                            <div className="custom-header-checkbox">
                                                <Form>
                                                    <div className={`custom-checkbox-div ${this.checkBoxChecked(location.locationid, 'unsuspend') ? 'checked' : ''}`} onClick={(event) => this.suspendInputChange(event, 'unsuspend', 'locationid', location['locationid'])}></div>
                                                </Form>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            ))
                        }
                    </Modal.Body>
                    <Modal.Footer >
                        <div id="toaster" className={this.state.suspendStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                            {
                                this.state.suspendStatus.show ?
                                    <ToasterMessage type={this.state.suspendStatus.type} message={this.state.suspendStatus.message} className="alert-handle"></ToasterMessage>
                                    : null
                            }
                        </div>
                        <div className="d-flex justify-content-end align-items-end">
                            <div className="d-flex">
                                <Button onClick={() => this.resetUnSuspend()} disabled={this.state.suspendLoading} className="btn-white">Cancel</Button>
                                <Button onClick={() => this.submitUnSuspend()} disabled={!this.state.form.unsuspend.valid || this.state.suspendLoading || this.state.UnsuspendDisable} className="btn-secondary ml-2">Unsuspend {this.state.suspendLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.invoiceModal} className={`invoiceModal ${this.state.windowWidth > 780 ? 'modal-dialog-centered' : ''}`} onHide={() => { this.setState({ invoiceModal: false }) }}>
                    <Modal.Header style={{ display: "contents", marginTop: "-5%", marginRight: "1%" }}>
                        <button type="button" className="close" onClick={() => { this.setState({ invoiceModal: false }) }}>
                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "2rem" }}>×</span>
                            <span class="sr-only">Close</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <InvoiceView id={this.state.invoiceId} type={this.state.invoiceType} />
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.resetModal} size="md" animation={false} onHide={() => { this.setState({ resetModal: false }) }} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Would you like to reset the  password for this User
                            <div className="d-flex flex-row mt-4">
                                <Button variant="outline-dark btn-white mx-2" style={{ width: '80px' }} onClick={() => { this.setState({ resetModal: false }) }}>Cancel</Button>
                                <Button variant="secondary mx-2" style={{ width: '80px' }} onClick={() => this.resetPassword()}>Confirm</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.deleteModal} size="md" animation={false} onHide={() => { this.setState({ deleteModal: true }) }} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Would you like to delete this User ?
                           <div id="toaster" className={this.state.deleteStatus.show ? " d-flex flex-row align-items-center justify-content-center toaster" : ''} style={{ paddingTop: "3%" }} >
                                {
                                    this.state.deleteStatus.show ?
                                        <ToasterMessage type={this.state.deleteStatus.type} message={this.state.deleteStatus.message} className="alert-handle"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex flex-row mt-4">
                                <Button variant="outline-dark btn-white mx-2" style={{ width: '120px' }} onClick={() => { this.redirectDeleteModal() }}>Cancel</Button>
                                <Button variant="secondary mx-2" style={{ width: '120px' }} disabled={this.state.deleteStatus.type === 'success'} onClick={() => this.deleteUser()}>Confirm {this.state.deleteLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                { this.state.form.buyerSuspendCount ? <Modal centered show={this.state.showSuspendedModal} className="suspendModal" scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <Row xs={1} sm={1} className="w-100">
                            <Col md={3}><h5>Location</h5></Col>
                            <Col md={2}><h5>Reason</h5></Col>
                            <Col md={2}><h5>Suspension Type</h5></Col>
                            <Col md={2}><h5>Suspension Date</h5></Col>
                            <Col md={2}><h5>Suspended By</h5></Col>
                        </Row>
                        <Button type="button" onClick={() => {this.setState({ showSuspendedModal: false })}} className="close-suspension" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button> 
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.state.suspendList
                            .slice()
                            .sort((a, b) => a.locationtitle.localeCompare(b.locationtitle)).map(response =>
                                <div className="border-bottom">
                                    <Row xs={1} sm={1} className="w-100 p-3">
                                        <Col md={3} style={{ wordBreak: "break-word" }}><b>{response['locationtitle'] ? response['locationtitle'] : '- - -' }</b></Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['reason'] ? response['reason'] : 'Added to Sitewide Suspensions' }</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['suspensiontype'] ? response['suspensiontype']  : 'Location Status Update' }</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{moment.utc(response['effectivedate']).local().format('MM-DD-YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['suspendedby'] ? response['suspendedby'] : 'System Update'}</Col>
                                    </Row>
                                </div>
                            )
                        }
                    </Modal.Body>
                </Modal> : ''}

                <Modal centered show={this.state.form.unsuspendReason.unsuspendReasonModal} className="reasonModal" onHide={() => this.setState({ ...this.state })} scrollable={true}>
                    <Modal.Body>
                        <div className="form-fields" style={{ width: "95%" }}>
                            <div className="d-flex" style={{ marginBottom: "10px" }}>
                                <small className='text-danger'>If you need the suspension lifted for the entire network, please contact <span style={{ color: '#A50050', cursor: 'pointer' }} onClick={() => navigateToHelpCenter(this.props.history)}>CTBids.com/help-center</span> </small>
                            </div>
                            <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Label htmlFor="revokereason" className="required">UnSuspension Reason</Form.Label>
                                <Form.Control as="select" name="suspension" value={this.state.form.unsuspendReason.revoketype.value} onChange={(event) => this.suspendInputChange(event, 'unsuspendReason', 'revoketype')}>
                                    <option value="" selected>--Select--</option>
                                    {
                                        UNSUSPENSION_REASON.map((elem, index) => {
                                            return <option key={index} value={elem}>{elem}</option>
                                        })
                                    }
                                </Form.Control> 
                            </div>
                            <div className="d-flex" style={{ color: '#878787' }}>
                                <Form.Label htmlFor="revokereason" className="required">Add Notes</Form.Label>
                                <span className="align-self-end ml-auto mb-1">{400 - this.state.form.unsuspendReason.revokereason.value.length}/400</span>
                            </div>
                            <div className="float-control">

                                <Form.Control as="textarea" id="revokereason" name="revokereason" value={this.state.form.unsuspendReason.revokereason.value} maxLength="400" className={this.state.form.unsuspendReason.revokereason.value ? 'form-control-active' : ''} style={{ height: '100px' }} placeholder=" " onChange={(event) => this.suspendInputChange(event, 'unsuspendReason', 'revokereason')} />
                                <div className="text">
                                    {
                                        this.state.form.unsuspendReason.revokereason.error && this.state.form.unsuspendReason.revokereason.error.length ? <small className="error">{this.state.form.unsuspendReason.revokereason.error}</small> : null
                                    }
                                </div>

                            </div>
                        </div>
                        <div>
                            <div id="toaster" className={this.state.suspendStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                {
                                    this.state.suspendStatus.show ?
                                        <ToasterMessage type={this.state.suspendStatus.type} message={this.state.suspendStatus.message} className="alert-handle"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex justify-content-center align-item-center">
                                <Button className="btn-white mx-2" onClick={() => this.resetUnSuspend()}>Cancel</Button>
                                <Button variant="secondary" onClick={() => this.setUnSuspendReasonModal()} disabled={!this.state.form.unsuspendReason.revokereason.value || !this.state.form.unsuspendReason.revoketype.value}>Confirm {this.state.suspendLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                { this.state.form?.unsuspendedcount > 0 ? <Modal centered show={this.state.unsuspensionModal} className="suspendModal" scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <Row xs={1} sm={1} className="w-100">
                            <Col md={3}><h5>Location</h5></Col>
                            <Col md={2}><h5>Reason</h5></Col>
                            <Col md={2}><h5>UnSuspension Type</h5></Col>
                            <Col md={2}><h5>UnSuspension Date</h5></Col>
                            <Col md={2}><h5>UnSuspended By</h5></Col>
                        </Row>
                        <Button type="button" onClick={() => {this.setState({ unsuspensionModal: false })}} className="close-suspension" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button> 
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.state.unsuspendList.map(response =>
                                <div className="border-bottom">
                                    <Row xs={1} sm={1} className="w-100 p-3">
                                        <Col md={3} style={{ wordBreak: "break-word" }}><b>{response['locationtitle'] ? response['locationtitle']  : '- - -'}</b></Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['revokereason'] ? response['revokereason']  : '- - -' }</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['revoketype']? response['revoketype'] :  '- - -'}</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{moment.utc(response['revokedate']).local().format('MM-DD-YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['revokedby'] ? response['revokedby'] : '- - -'}</Col>
                                    </Row>
                                </div>
                            )
                        }
                    </Modal.Body>
                </Modal> : ''}

            </div>
        );
    }
}